import { useState } from "react";
import DualListSelectComponent from "./dualListSelect.component";

export default function DualListSelectContainer({
  list,
  selectedList,
  nameRef,
  availableTitle = 'Available',
  selectedTitle = 'Selected',
  isFetching,
  onChange,
}) {
  const [leftList, setLeftList] = useState(list.filter((item) => !selectedList.includes(item)));
  const [rightList, setRightList] = useState(selectedList);
  const [leftSelected, setLeftSelected] = useState([]);
  const [rightSelected, setRightSelected] = useState([]);

  const [leftSearch, setLeftSearch] = useState("");
  const [rightSearch, setRightSearch] = useState("");

  const onLeftSelect = (value) => {
      setLeftSelected(leftSelected.includes(value)
        ? leftSelected.filter((item) => item !== value)
        : [...leftSelected, value]
      );
  };

  const onRightSelect = (value) => {
    setRightSelected(rightSelected.includes(value)
      ? rightSelected.filter((item) => item !== value)
      : [...rightSelected, value]
    );
  };

  const onToRight = () => {
    const newLeftList = leftList.filter((item) => !leftSelected.includes(item));
    const newRightList = [...rightList, ...leftSelected];
    setLeftList(newLeftList);
    setRightList(newRightList);
    setLeftSelected([]);
    onChange(newRightList);
  };

  const onToLeft = () => {
    const newRightList = rightList.filter((item) => !rightSelected.includes(item));
    const newLeftList = [...leftList, ...rightSelected];
    setRightList(newRightList);
    setLeftList(newLeftList);
    setRightSelected([]);
    onChange(newRightList);
  };

  const onAllToRight = () => {
    const newRightList = [...rightList, ...leftList];
    setRightList(newRightList);
    setLeftList([]);
    setLeftSelected([]);
    onChange(newRightList);
  };

  const onAllToLeft = () => {
    const newLeftList = [...leftList, ...rightList];
    setLeftList(newLeftList);
    setRightList([]);
    setRightSelected([]);
    onChange([]);
  };

  const onLeftSearchChange = (event) => {
    setLeftSearch(event.target.value);
  };

  const onRightSearchChange = (event) => {
    setRightSearch(event.target.value);
  };

  const getName = (value) => nameRef[value] || value;

  return (
    <DualListSelectComponent
      leftList={leftList}
      rightList={rightList}
      leftSelected={leftSelected}
      rightSelected={rightSelected}
      getName={getName}
      titleLeft={availableTitle}
      titleRight={selectedTitle}
      isFetching={isFetching}
      onLeftSelect={onLeftSelect}
      onRightSelect={onRightSelect}
      onToRight={onToRight}
      onToLeft={onToLeft}
      onAllToRight={onAllToRight}
      onAllToLeft={onAllToLeft}
      onLeftSearchChange={onLeftSearchChange}
      onRightSearchChange={onRightSearchChange}
      leftSearch={leftSearch}
      rightSearch={rightSearch}
    />
  );
}
